// src/pages/Products/Facilities/ShelterBus.jsx
import React from 'react';
import styled from 'styled-components';
import HeroSection from '../../../components/ProductsDetail/HeroSection';
import ProductShowcaseSection from '../../../components/ProductsDetail/ProductShowcaseSection';
import CTASection from '../../../components/ProductsDetail/CTASection';
import {
  InfoSection, 
  UsageGrid,
  UsageHighlight,
} from '../../../components/ProductsDetail/InfoBlocks';
import SectionDivider from '../../../components/ProductsDetail/SectionDivider';
import ProductDetailNav from '../../../components/ProductsDetail/ProductDetailNav';

const ShelterBus = () => {
  return (
    <>
      <HeroSection
        title={`쉼 in 카`}
        subtitle={`도로 작업자들의 근무환경 개선을 위한 \n이동식 복지 공간을 제공합니다`}
        backgroundImage="/images/products/facilities/shelter-bus.jpg"
        breadcrumbs={[
          { label: '홈', path: '/' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '쉼 in 카' },
        ]}
        categories={[
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '도로 안내표지시스템', path: '/products/signage' },
        ]}
      />

      <ProductShowcaseSection
        subtitle={`이동식 근로자 쉼터`}
        title={`쉼 in 카`}
        description={
          <>
            고속도로 등의 유지관리 작업장 근무환경 개선을 위해 대형버스를 개조하여 작업 현장에서{' '}
            <strong>휴게실, 화장실, 음료 공간</strong>을 제공함으로써 온열질환 예방의 핵심 수칙
            (<strong>물·그늘·휴식</strong>)을 실질적으로 준수합니다.
            <br />
            <br />
            제세동기, 응급 구호 장비를 비치하여 사고 발생 시 즉각 대응이 가능하도록 준비함으로써,
            비상 상황에서도 작업자의 안전을 사전에 확보합니다.
          </>
        }
        images={[
          '/images/products/facilities/shelter-bus1.webp',
          '/images/products/facilities/shelter-bus2.jpg',
          '/images/products/facilities/shelter-bus3.jpg',
          '/images/products/facilities/shelter-bus4.jpg',
          '/images/products/facilities/shelter-bus5.webp',
          '/images/products/facilities/shelter-bus6.jpg',
          '/images/products/facilities/shelter-bus7.jpg',
        ]}
      />

      <SectionDivider />

      <InfoSection title="외부사진">
        <UsageGrid
          columns={2}
          items={[
            {
              image: '/images/products/facilities/shelter-bus-outside2.jpg',
            },
            {
              image: '/images/products/facilities/shelter-bus-outside1.jpg',
            },
          ]}
        />
      </InfoSection>

      {/* 1. 내부 사진 */}
      <InfoSection title="내부사진">
        <UsageGrid
          items={[
            {
              image: '/images/products/facilities/shelter-bus-inner5.webp',
            },
            {
              image: '/images/products/facilities/shelter-bus4.jpg',
            },
            {
              image: '/images/products/facilities/shelter-bus-inner1.jpg',
            },
            {
              image: '/images/products/facilities/shelter-bus-inner7.jpg',
            },
          ]}
        />
      </InfoSection>

      {/* 2. 고속도로 현장사진 */}
      <InfoSection title="고속도로 현장사진">
        <UsageGrid
          columns={3}
          items={[
            {
              image: '/images/products/facilities/shelter-bus-install2.jpg',
            },
            {
              image: '/images/products/facilities/shelter-bus-install1.jpg',
            },
            {
              image: '/images/products/facilities/shelter-bus-install3.jpg',
            },
          ]}
        />
      </InfoSection>

      {/* 3. 실제 활용 사진 – 휴식 공간으로 활용 */}
      <InfoSection title="실제 활용사진">
        <UsageHighlight
          // eyebrow="현장 활용 예시"
          title="1. 작업자 휴식 공간 활용"
          body={`- 현장 근로자는 작업 중에도 물과 음료를 손쉽게 섭취할 수 있으며, 화장실과 휴게 공간을 현장에서 바로 이용함으로써 이동 시간을 최소화할 수 있습니다.
             - 이를 통해 근로자들은 휴식과 수분 섭취를 꾸준히 유지하며, 높은 집중력과 효율적인 작업 수행이 가능합니다.`}
        />

        <UsageGrid
          columns={2}
          autoHeight
          items={[
            {
              image: '/images/products/facilities/shelter-bus-rest2.jpg',
            },
            {
              image: '/images/products/facilities/shelter-bus-rest4.jpg',
            },
            {
              image: '/images/products/facilities/shelter-bus-rest1.jpg',
            },
            {
              image: '/images/products/facilities/shelter-bus-rest3.jpg',
            },
          ]}
        />

        <UsageHighlight
          // eyebrow="현장 활용 예시"
          title="2. 작업자 안전 교육 "
          body={`- 작업 전 안전교육 시 내부 공간을 활용하여, 근로자가 교육 자료를 시청하고 안전장비를 점검하며 실습을 진행할 수 있는 종합 안전교육 공간으로 활용됩니다.
            - 근로자는 안전요령을 실질적으로 이해하고 현장에 즉시 적용할 수 있어, 안전교육 효과를 극대화하고 사고 예방과 근로자 보호에 기여합니다.`}
        />

        <UsageGrid
          columns={2}
          autoHeight
          items={[
            {
              image: '/images/products/facilities/shelter-bus-edu1.webp', 
            },
            {
              image: '/images/products/facilities/shelter-bus-edu4.jpg',
            },
            {
              image: '/images/products/facilities/shelter-bus-edu2.jpg',
            },
            {
              image: '/images/products/facilities/shelter-bus-edu3.jpg',
            },
          ]}
        />
      </InfoSection>


      <ProductDetailNav
        category="facilities"
        currentPath="/products/facilities/shelter-bus"
        listPath="/products/facilities"
      />

      

      <CTASection />
    </>
  );
};

export default ShelterBus;
